import React from 'react';
import { SvgIcon } from '@mui/material';

export default function CVIcon() {
  return (
    <SvgIcon sx={{ width: 24, height: 24 }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.33805 2.03302C4.33805 2.00659 4.33873 1.98031 4.34008 1.95422C4.38106 1.16468 5.03422 0.537109 5.83395 0.537109H20.0275C20.8537 0.537109 21.5234 1.20685 21.5234 2.03302V20.5229C21.5234 20.6498 21.5077 20.7729 21.4779 20.8905C21.3141 21.539 20.7269 22.0189 20.0275 22.0189H19.6599H5.83395C5.00779 22.0189 4.33805 21.3491 4.33805 20.5229V2.03302Z"
          fill="#BDB1FE"
        />
        <path
          d="M2.47656 3.45013C2.47656 3.34644 2.48711 3.24521 2.5072 3.14746C2.64714 2.4664 3.24999 1.95422 3.97247 1.95422H4.34008H18.166C18.9922 1.95422 19.662 2.62396 19.662 3.45013V21.9401C19.662 21.9665 19.6613 21.9928 19.6599 22.0189C19.6189 22.8084 18.9658 23.436 18.166 23.436H3.97247C3.1463 23.436 2.47656 22.7662 2.47656 21.9401V3.45013Z"
          fill="#A799FE"
        />
        <path
          d="M10.3386 12.1125H8.68284C8.6711 11.9755 8.63978 11.8512 8.5889 11.7397C8.53997 11.6281 8.47147 11.5322 8.3834 11.452C8.29729 11.3698 8.19258 11.3071 8.06928 11.2641C7.94599 11.2191 7.80605 11.1966 7.64948 11.1966C7.37549 11.1966 7.14357 11.2631 6.95373 11.3962C6.76585 11.5293 6.62298 11.7201 6.52512 11.9686C6.42922 12.2172 6.38127 12.5157 6.38127 12.864C6.38127 13.232 6.4302 13.5402 6.52806 13.7888C6.62787 14.0354 6.77172 14.2213 6.9596 14.3465C7.14748 14.4698 7.37353 14.5315 7.63774 14.5315C7.78844 14.5315 7.92348 14.5129 8.04286 14.4757C8.16225 14.4366 8.26597 14.3808 8.35404 14.3084C8.44211 14.236 8.51355 14.1489 8.56835 14.0471C8.6251 13.9434 8.66327 13.8269 8.68284 13.6978L10.3386 13.7095C10.319 13.9639 10.2476 14.2232 10.1243 14.4874C10.001 14.7497 9.82579 14.9924 9.59877 15.2155C9.3737 15.4366 9.09481 15.6147 8.7621 15.7498C8.42939 15.8848 8.04286 15.9523 7.60251 15.9523C7.05061 15.9523 6.55546 15.8339 6.11706 15.5971C5.68063 15.3603 5.3352 15.012 5.08077 14.552C4.8283 14.0921 4.70207 13.5294 4.70207 12.864C4.70207 12.1947 4.83124 11.631 5.08958 11.1731C5.34792 10.7132 5.69628 10.3658 6.13468 10.1309C6.57307 9.8941 7.06235 9.77569 7.60251 9.77569C7.98219 9.77569 8.33154 9.82756 8.65055 9.93128C8.96956 10.035 9.24942 10.1867 9.49015 10.3863C9.73087 10.584 9.92463 10.8276 10.0714 11.1173C10.2182 11.4069 10.3072 11.7387 10.3386 12.1125Z"
          fill="white"
        />
        <path
          d="M12.6404 9.85789L13.8734 14.097H13.9203L15.1533 9.85789H16.9969L15.0124 15.8701H12.7813L10.7968 9.85789H12.6404Z"
          fill="white"
        />
        <path
          d="M4.34008 1.95422C4.38106 1.16468 5.03422 0.537109 5.83395 0.537109C3.48633 0.537109 2.66967 2.12545 2.5072 3.14746C2.64714 2.4664 3.24999 1.95422 3.97247 1.95422H4.34008Z"
          fill="#9A8AFE"
        />
        <path
          d="M20.0275 22.0189H19.6599C19.6189 22.8084 18.9658 23.436 18.166 23.436C19.1401 23.5742 21.0942 23.2367 21.4779 20.8905C21.3141 21.539 20.7269 22.0189 20.0275 22.0189Z"
          fill="#9A8AFE"
        />
      </svg>
    </SvgIcon>
  );
}
